<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article class="post-30 page type-page status-publish hentry">
          <div class="entry-content">
            <!-- PHASE 1 -->
            <div class="hc-managed-firewall hc-managed-firewall-color">
              <div class="container">
                <div class="row">
                  <div class="col-sm-6">
                    <h2 class="wow fadeIn">Internet Business Issues</h2>
                    <div class="wow fadeIn margin-top-bottom-30">
                      <p>
                        With the rapid development of information technology,
                        data creation is skyrocketing upwards, inundating
                        businesses with massive amounts of new, insight-rich
                        information/data. We are allowed, in general, to use the
                        information/data the way we wish mostly without the
                        knowledge, understanding or consent of the
                        originator/owner. Cybercriminals, hackers and other
                        kinds of cyber harassers use this opportunity basically
                        with malicious intention to harm businesses/individuals.
                        In today’s world reportedly, many businesses are badly
                        affected by the misuse or abuse of cyberspace.
                        Fake/false reviews, brand impersonation, usurpation of
                        IP and infringement of copyright have become the most
                        common acts of cyber harassments or crimes making a huge
                        negative impact on business today both the small and
                        large scale.
                      </p>
                      <p>
                        A general explanation of most common forms of internet
                        business issues with their related concepts is given
                        below.
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wow fadeIn">
                      <img
                        class="aligncenter size-full hc-managed-firewall-img"
                        src="/static/assets/images/internet_business_issues.png"
                        alt="Managed-Firewall-layer-1"
                        style="max-width: 100%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- PHASE 3 -->
            <div class="hc-home-hosting-wp-support">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn no-margin hc-h1">
                      Fake / False Reviews of Business
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Online reviews performed by customers are extensively
                        used nowadays by the general public, particularly
                        potential customers, to assess and rate the quality of a
                        business company and its products/ services. Fake/false
                        reviews have become a serious issue for many business
                        organizations today, not only large scale but also small
                        and medium, both manufacturing and services,
                        particularly in the fields of online services, local
                        businesses, tours and travels, hotels and restaurants,
                        e-commerce sites, app stores and many others.
                      </p>
                      <br />
                      <p class="hc-p">
                        Fake/false reviews can attack the reputation of any
                        business organization directly and destroy it
                        completely. They may appear as false, defamatory or
                        illegal reviews written by unsatisfied customers or
                        misleading and deceptive reviews written by competitors
                        or simply a fake review written by any person with a
                        vicious intention. Therefore, any business organization
                        will not like to have any kind of fake/false reviews in
                        their websites, if it competes with any other
                        organization, product or service.
                      </p>
                      <br />
                      <p class="hc-p">
                        “Clear Me Out” provides assistance to organizations,
                        having any kind of fake/false reviews in their websites
                        by removing the content of such reviews completely.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <div class="spacer_10"></div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Brand impersonation
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Brand impersonation has been identified as another kind
                        of cyber-fraud/crime in business today, which is
                        initiated by creating a page or an account on social
                        media by an impostor exploiting victim’s brand for their
                        own gain. In this process, they strive to gain the
                        confidence of trusted customers as well as carryout
                        harmful activities against the brand. This has become an
                        increasingly common problem on social media today and
                        many reputed organizations are forced to deal with this
                        problem.
                      </p>
                      <br />
                      <p class="hc-p">
                        The latest trend in cyber harassing, rather hacking, is
                        the stealing of professional information of successful
                        business owners and CEOs of large companies.
                        Cybercriminals are motivated to access information
                        accounts of high profile people because its gain is more
                        than accessing such people’s bank accounts. Hackers
                        target small businesses too with the idea of destroying
                        a larger company connected to the small business. Such
                        small businesses may have access to huge amounts of data
                        and as a result of hacking both the companies, the small
                        and the connected big, could be found themselves out of
                        business.
                      </p>
                      <br />
                      <p class="hc-p">
                        In today’s competitive world, any company can be
                        victimized by fake or false images, audios &amp; videos
                        or contents published in online news, blogs, web
                        articles or online magazines. Such fake or false
                        contents could be very harmful to the reputation of any
                        business organization, irrespective of its scale or
                        nature of business. Therefore, business companies are
                        compelled to obtain the services of online brand
                        protection to defend themselves against loss of revenue,
                        customer trust and loyalty. Companies which are not
                        taking this seriously and/or not vigilant about their
                        brand security may face the problem of brand
                        impersonation, misusing of their brand by culprits for
                        disseminating fraudulent messages, or simply
                        misrepresenting their brand in the market.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h1 class="wow fadeIn margin-top-bottom-30 hc-h1">
                      Intellectual Property Rights Enforcement
                    </h1>
                    <div
                      class="wow fadeIn margin-top-bottom-30"
                      style="margin-bottom: 0px !important"
                    >
                      <p class="hc-p">
                        Companies as well as individuals spend their time,
                        effort, money and other resources together with their
                        talents in the process of creating something their own
                        or innovating a new piece of work which can be a book,
                        poem, research paper, song, lyrics, melody, composition,
                        photograph, painting, drawing, movie, video, product or
                        software. When such creations or innovations are used by
                        another person or any other organization for their
                        benefit, without the consent of originator or
                        compensating the originator for work accomplished, the
                        act would be identified as a theft.
                      </p>
                      <br />
                      <p class="hc-p">
                        In today’s digital world, with the use of the internet,
                        copyright infringement and the usurpation of
                        intellectual property (IP) are taking place within
                        seconds. If this happens to an individual, his/her whole
                        life could be ruined, or a company, the impact could be
                        more significant including lost of sales, lost of
                        customers and lower profit margins and close down of
                        business.
                      </p>
                      <br />
                      <p class="hc-p">
                        Many business organizations report about their
                        potentially critical business losses due to failure to
                        adequately protect their IP. Such incidents normally
                        happen because of their own failure or due to unlawful
                        act of an offender. This is identified as a cyber-risk
                        and it has become one of the most significant risks in
                        the business world today. Data are everywhere and
                        therefore, it is harder to control unless we have a
                        proper system for their protection and management.
                      </p>
                      <br />
                      <p class="hc-p">
                        If you are frustrated with finding any of your contents
                        used or published without your consent in the internet,
                        we are ready to help you get it removed quickly and
                        furthermore, manage your reputation with our content
                        monitoring and removal process.
                      </p>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <!-- PHASE 4 -->
            <div class="clearfix"></div>
            <div class="hc-start-web">
              <div class="container">
                <div class="row">
                  <div class="col-sm-8">
                    <h3 class="wow fadeIn" style="color: white">
                      To get an understanding on services we offer to
                      businesses, please click
                    </h3>
                  </div>
                  <div class="col-sm-4">
                    <div class="spacer_7"></div>
                    <div class="clearfix"></div>
                    <div class="hc-btn-read-more-bk-red wow fadeIn">
                      <a href="/business" title>Business Service</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
// /*---------------------------------------------*/
// /*--- 20. ANIMATION DOMAIN NAME ---------------*/
// /*---------------------------------------------*/
/* eslint-disable */
setTimeout(function () {
  //moving slider
  var scrollSpeed = 60; // Speed in milliseconds
  var step = 1; // How many pixels to move per step
  var current = 0; // The current pixel row
  var imageWidth = 3473; // Background image width
  var headerWidth = 1170; // How wide the header is.

  //The pixel row where to start a new loop
  var restartPosition = -(imageWidth - headerWidth);

  function scrollBg() {
    //Go to next pixel row.
    current += step;

    //If at the end of the image, then go to the top.
    if (current == restartPosition) {
      current = 0;
    }

    //Set the CSS of the header.
    // jQuery(".slider-moving").css("background-position", current + "px 0");
  }

  // setInterval(scrollBg, scrollSpeed);

  jQuery(".mt_typed_text_5b48675d69375").typed({
    strings: [
      "your content",
      "your data",
      "your brand",
      "your IP",
      "your reputation",
      "your privacy",
    ],
    typeSpeed: 0.1,
    backDelay: 3000,
    loop: true,
  });
});

export default {
  name: "personal_harassment",
  data() {
    return {
      msg: "Clear Me Out - Personal Cyber Harassments",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/business_problems.vue